<template>
  <pull-to class="eds-message-box-root" :top-load-method="onRefresh" @infinite-scroll="onAppend"
    :top-config="TOP_DEFAULT_CONFIG" :bottom-config="BOTTOM_DEFAULT_CONFIG">
    <div class="eds_no_info_outer" v-if="!sessionList || sessionList.length == 0">
      <div class="eds_no_info_inner">
        <img src="imgs/svg/eds/no_message.svg" />
        <div>{{ $t('暂无消息') }}</div>
      </div>
    </div>
    <div v-else row wrap style="width: 100%">
      <v-flex flat xs12 class="session_content" v-for="(session, index) in sessionList" :key="index"
        @click="onShowMessages(session)">
        <div class="img-bg">
          <img v-if="session.icon && session.icon != ''" :src="session.icon" />
          <img v-else :src="getIcon(session)" />
        </div>
        <div class="session_content_main">
          <div class="session_content_main_first">
            <span class="session_content_name">
              {{ getSessionName(session) }}
            </span>
            <span class="session_content_sendTime">
              {{ `${Math.abs(session.sendTime / 1000000000 - Math.ceil(Date.now() / 1000 / 86400) * 86400) >= 86400 ?
                `${convertDate(session.sendTime).substr(5, 5).replace(/^0/, '').replace('-', $t('月'))}` + $t('日') :
                convertDate(session.sendTime).substr(11)}` }}
            </span>
          </div>
          <div class="session_content_second">
            {{ getLastMsg(session) }}
          </div>
        </div>
      </v-flex>
    </div>
    <div v-if="!isDefault" class="eds_loading_bar">
      <span>{{ loadingText }}</span>
    </div>
    <iDS-GoTop></iDS-GoTop>
  </pull-to>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import APP_CONFIG from '../../config/App'
import { SESSION_TYPE } from '../../config/Message'
import PullTo from 'vue-pull-to'
import iDSGoTop from '../../components/iDSGoTop'
import dateHelper from '../../util/date'
import dbHelper from '../../util/db'
import debugHelper from '../../util/debug'
import msgbus from '../../msgBus'
import eDSCompSearch from '../../components/eDSCompSearch'

export default {
  name: 'eDS-MessageBox',
  components: {
    PullTo,
    iDSGoTop,
    eDSCompSearch,
  },
  data() {
    return {
      TOP_DEFAULT_CONFIG: APP_CONFIG.tTOP_DEFAULT_CONFIG(),
      BOTTOM_DEFAULT_CONFIG: APP_CONFIG.tBOTTOM_DEFAULT_CONFIG(),
      searchSetInfo: '',

      event: '',
      pageIndex: 0, // 页码
      pageSize: 10, // 每页记录数
      listRecordCount: 0, // 已经加载的总记录数
      loadingText: '',

      // 测试数据
      sessionList1: [
        {
          cid: '5f476811e138232261abc046',
          id: '5f3261bd6dd12c4ac027a775', // 会话编号
          type: 'work', // 会话类型: work/system
          name: '工作通知：杭州数络信息技术有限公司3333333333', //会话名称
          sendTime: 1597029272000000000, // 最后一条消息接收时间
          lastMsg:
            '[审批]陈雪峰提交的文件解密申请需要你审批3333333333333333333', // 最后一条消息
          icon: 'imgs/svg/eds/dataLink.png', // 会话图标URL
        },
        {
          id: '5f3261bd6dd12c4ac027a776',
          type: 'system',
          name: '系统公告',
          sendTime: 1597029272000000000,
          lastMsg: 'V1.6版本发布 | 提升了启动速度，解决已知的问题',
          icon: 'imgs/svg/eds/notifications.svg',
        },
      ],
    }
  },
  computed: {
    isDefault() {
      return this.sessionList == null || this.sessionList.length == 0
    },
    sessionList() {
      // 启用测试数据
      // return this.sessionList1
      return msgbus.vm.getSessions()
    },
    totalCount() {
      return msgbus.vm.getSessionsTotalCount()
    },
  },
  methods: {
    // 获取图标
    getIcon(session) {
      return SESSION_TYPE[session.type].icon
    },
    getSessionName(session) {
      let name = session.name // 工作: dev-ydr测试
      // 截取：工作，并进行多语言翻译
      let index = name.indexOf(':')
      if (index != -1) {
        let info1 = name.substring(0, index)
        let info2 = name.substring(index, name.length)
        name = this.$t(info1) + info2
      }
      return name
    },
    getLastMsg(session) {
      let lastMsg = session.lastMsg // [审批]测试1提交的文件解密申请
      // 截取：审批，并进行多语言翻译
      let index1 = lastMsg.indexOf('[')
      let index2 = lastMsg.indexOf(']')
      if (index1 != -1 && index2 != -1) {
        let info1 = lastMsg.substring(1, index2)
        let info2 = lastMsg.substring(index2, lastMsg.length)
        lastMsg = '[' + this.$t(info1) + info2
      }
      if (msgbus.vm.isEDS16()) {
        lastMsg = lastMsg + this.$t('需要您审批')
      }
      return lastMsg
    },
    // 刷新
    onRefresh(loaded) {
      // 初始加载0条记录
      this.listRecordCount = 0

      // 查询第一页消息会话
      var data = {
        keyword: this.searchSetInfo,
        order: '-sendTime',
        skip: 0,
        limit: this.pageSize,
      }
      msgbus.vm
        .fetchSessions({
          authorization: {
            Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
          },
          data: data,
          vm: msgbus.vm,
        })
        .then(
          () => {
            this.listRecordCount += this.pageSize
            if (loaded != null) {
              loaded('done')
            }
          },
          () => {
            if (loaded != null) {
              loaded('done')
            }
          }
        )
    },
    // 翻页
    onAppend(loaded) {
      if (this.listRecordCount < this.totalCount) {
        this.loadingText = this.$t('加载中...')
        // 查询下一页消息会话
        var data = {
          keyword: this.searchSetInfo,
          order: '-sendTime',
          skip: this.listRecordCount,
          limit: this.pageSize,
        }
        msgbus.vm
          .appendSessions({
            authorization: {
              Authorization: 'Bearer ' + msgbus.vm.getAccountToken(),
            },
            data: data,
            vm: msgbus.vm,
          })
          .then(
            () => {
              this.listRecordCount += this.pageSize
              if (loaded != null) {
                loaded('done')
              }
            },
            () => {
              if (loaded != null) {
                loaded('done')
              }
            }
          )
      } else {
        if (loaded != null) {
          loaded('fail')
        }
        this.loadingText = this.$t('已经到底了')
      }
    },
    // 搜索
    onSaveSearchSet(searchSetInfo) {
      this.searchSetInfo = searchSetInfo
      // 刷新
      this.onRefresh()
    },
    // 显示具体消息
    onShowMessages(session) {
      this.$router.push({ name: 'messagelist', params: { session: session } })
    },
    // 转化时间
    convertDate(sendTime) {
      return dateHelper.timestamp2LocalTime(sendTime / 1000000000)
    },
    // 切换界面样式
    changeView() {
      msgbus.vm.setTitleList({
        visible: false,
        list: [],
        listIcon: [],
        change: () => { },
        curValue: '',
        curIcon: '',
      })
      msgbus.vm.setTitle(this.$t('消息'))
      msgbus.vm.setTitleVisible(true)
      msgbus.vm.setBackDisabled(true)
      msgbus.vm.setBackIcon('')
      msgbus.vm.setBottomNavVisible(true)
      msgbus.vm.setBottomBtnVisible(false)

      msgbus.vm.setContentHeight({
        value:
          `calc(${window.innerHeight
          }px - 48px - ${msgbus.vm.getContentBottomHeight()} ` + ')',
      })
    },
  },
  created() {
    console.log('调试代码')
    if (msgbus.vm.getAccountToken() == null) {
      window.location.href = '/'
      return
    }
    // 读取页面加载的总记录数
    var listRecordCountTmp = parseInt(dbHelper.get('listRecordCount'))
    this.listRecordCount = isNaN(listRecordCountTmp) ? 0 : listRecordCountTmp
    if (msgbus.vm.getSessions().length == 0 || this.listRecordCount == 0) {
      // 显示信息
      this.onRefresh()
    } else {
      this.event = 'updateScrollTop'
      if (this.listRecordCount < this.totalCount) {
        this.loadingText = this.$t('加载中...')
      } else {
        this.loadingText = this.$t('已经到底了')
      }
    }

    // 切换界面样式
    this.changeView()
  },
  mounted() {
    debugHelper.log(this.event)
    switch (this.event) {
      case 'updateScrollTop':
        var scroll = document.getElementsByClassName('scroll-container')[0]
        var Top = dbHelper.get('listScrollTop')
        debugHelper.log('获取scrollTop : ' + Top)
        scroll.scrollTop = Top
        dbHelper.set('listScrollTop', 0)
        dbHelper.set('listRecordCount', 0)
        break
    }
    this.event = ''
  },
  updated() {
    // 页面刷新过了，去红点
    msgbus.vm.setMessageTips({ value: 0 }) // 去红点

    debugHelper.log(this.event)
    switch (this.event) {
      case 'updateScrollTop':
        var scroll = document.getElementsByClassName('scroll-container')[0]
        var Top = dbHelper.get('listScrollTop')
        debugHelper.log('获取scrollTop : ' + Top)
        scroll.scrollTop = Top
        dbHelper.set('listScrollTop', 0)
        dbHelper.set('listRecordCount', 0)
        break
    }
    this.event = ''
  },
  beforeDestroy() {
    msgbus.vm.setMenuDisabled(true)
    msgbus.vm.setMenuItems([])
    msgbus.vm.setMenuIcon('')
  },
}
</script>

<style lang="scss">
.eds-message-box-root {
  &>.scroll-container {
    background: #f3f4f6;
    display: flex;
    flex-direction: column;

    &>.eds_no_info_outer {
      flex: 1;
      display: block;
      position: relative;

      &>.eds_no_info_inner {
        display: inline-block;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

  .session_content {
    background: #ffffff;
    height: 76px !important;
    padding: 12px 0;
    position: relative;

    & .img-bg {
      border: 1px solid #f3f4f6;
      position: absolute;
      width: 48px;
      height: 48px;
      top: 50%;
      left: 16px;
      transform: translateY(-50%);
      padding: 9px;
      border-radius: 8px;

      &>img {
        width: 28px;
        height: 28px;
      }
    }

    &::after {
      content: "";
      position: absolute;
      right: 0;
      bottom: 0;
      width: calc(100% - 76px);
      border-bottom: 1px solid #f3f4f6;
    }

    &:last-child {
      &::after {
        width: 100%;
      }
    }
  }

  .session_content_main {
    padding: 0 16px 0 76px;

    .session_content_main_first {
      display: flex;
      line-height: 28px;

      .session_content_name {
        flex: 1;
        // font-weight: 600;
        color: #000000;
        font-size: 16px;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        white-space: nowrap;
      }

      .session_content_sendTime {
        color: #a0a0a0;
        font-size: 14px;
        display: inline-block;
        // min-width: 80px;
      }
    }

    .session_content_second {
      color: #a0a0a0;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 24px;
    }
  }

  .session_content_main p {
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    margin-bottom: 2px;
  }
}
</style>
